// Shared helpers that make all calendar math happen in FACTORY_TZ: America/New_York.

import {
  formatInTimeZone,
  fromZonedTime,
} from 'date-fns-tz';

export const FACTORY_TZ = 'America/New_York';
export const CUTOFF_HOUR = 17; // 5 PM local factory time

// returns an instant (UTC-based epoch)
export const systemClock = () => new Date();

// Format a Date (instant) as the factory calendar date "YYYY-MM-DD"
export const fmtFactoryDate = (instant) => formatInTimeZone(instant, FACTORY_TZ, 'yyyy-MM-dd');

// General formatter in any IANA tz (good for UI)
export const fmtInTZ = (instant, tz, pattern = 'yyyy-MM-dd HH:mm zzz') => formatInTimeZone(instant, tz, pattern);

// Turn a factory calendar date string "YYYY-MM-DD" into a UTC instant
export function factoryLocalToUTC({
  ymd, hour = 0, minute = 0, second = 0,
}) {
  const hh = String(hour).padStart(2, '0');
  const mm = String(minute).padStart(2, '0');
  const ss = String(second).padStart(2, '0');
  return fromZonedTime(new Date(`${ymd}T${hh}:${mm}:${ss}`), FACTORY_TZ);
}

// Build today's cutoff (e.g., 17:00) *in factory local time* as a UTC instant
export function cutoffUTC(nowInstant) {
  const ymd = fmtFactoryDate(nowInstant); // "YYYY-MM-DD" in factory calendar
  return factoryLocalToUTC({ ymd, hour: CUTOFF_HOUR });
}

// Start-of-day (00:00) for the factory calendar day that contains `instant`,
// returned as a UTC instant.
export function startOfFactoryDayUTC(instant) {
  const ymd = fmtFactoryDate(instant);
  return factoryLocalToUTC({ ymd });
}

export function addFactoryDaysUTC(cursorUTC, days = 1) {
  // Get the factory-local calendar date for the cursor
  const ymd = fmtFactoryDate(cursorUTC); // "YYYY-MM-DD" in FACTORY_TZ
  // Treat that YMD as a plain date, bump by N days
  const tmp = new Date(`${ymd}T00:00:00Z`);
  tmp.setUTCDate(tmp.getUTCDate() + days);
  const nextYmd = tmp.toISOString().slice(0, 10); // "YYYY-MM-DD"
  // Convert the next factory-local midnight back to a UTC instant
  return factoryLocalToUTC({ ymd: nextYmd });
}
